const menuUserData = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
  <g fill="none" fill-rule="evenodd" transform="translate(1)">
    <g stroke="#F5F5F5" transform="translate(0 .75)">
      <g transform="translate(9.75 9)">
        <line x1="4.125" x2="4.125" y1="1.875" y2="6.375" stroke-linecap="round"/>
        <polyline stroke-linecap="round" stroke-linejoin="round" points="2.625 4.875 4.125 6.375 5.625 4.875"/>
        <circle cx="4.125" cy="4.125" r="3.75"/>
      </g>
      <g stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9.748 9.331 7.5 8.525 7.5 6.992"/>
        <path d="M4.5,6.99225 L4.5,8.52525 L1.54425,9.58425 C0.83625,9.83775 0.375,10.509 0.375,11.259 L0.375,12.375 L8.25,12.375"/>
        <path d="M8.96025,3.927 C8.96025,5.8905 7.63425,7.48275 6,7.48275 C4.36425,7.48275 3.03975,5.8905 3.03975,3.927 C3.03975,1.96575 4.36425,0.375 6,0.375 C7.635,0.375 8.96025,1.96575 8.96025,3.927 Z"/>
        <path d="M8.937 3.60825C8.838 3.62175 8.75625 3.61275 8.6565 3.633 7.64775 3.8265 7.0005 3.46125 6.44475 2.48925 6.11175 3.1275 5.0715 3.633 4.21575 3.633 3.79425 3.633 3.432 3.54675 3.06975 3.35625M10.875.375C12.51.375 13.83525 1.96575 13.83525 3.927 13.83525 5.8905 12.50925 7.48275 10.875 7.48275"/>
        <path d="M13.812,3.60825 C13.713,3.62175 13.63125,3.61275 13.5315,3.633 C12.52275,3.8265 11.8755,3.46125 11.31975,2.48925"/>
        <line x1="12.375" x2="12.375" y1="8.25" y2="6.992"/>
      </g>
    </g>
    <rect width="18" height="18"/>
  </g>
</svg>
`;

export default menuUserData;
